import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserdataService } from './userdata.service';

import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';
import { inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService {

    private router = inject(Router);
    private userdata = inject(UserdataService);
    private http = inject(HttpClient);
    private ms = inject(SnackService);

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            document.title = 'ideastream.io';
        } catch (error) { }


        return await new Promise<boolean>((resolve, reject) => {
            this.http.post(`${serverurl}/auth/checklogin`, {}).subscribe({
                next: async (data: any) => {
                    const userData = await this.userdata.data.getValue();
                    if (!userData && data) {
                        console.log(userData, data)
                        data.userdata.refreshtoken = new Date().getTime();
                        this.userdata.data.next(data.userdata);
                    }

                    if (userData?.status === 'CONFIRM') {
                        this.ms.error({ error: { msg: { headline: "Confirm your email", text: "You have to confirm your email or your account will be deleted." } } });
                    }

                    localStorage.setItem('ids_lastvisit', state.url);
                    resolve(true);
                },
                error: (err: any) => {
                    console.error('Fehler bei der Authentifizierung', err);
                    sessionStorage.clear();
                    localStorage.clear();

                    const backendMsg = err?.error?.msg;

                    if (backendMsg === 'unauthorizedUser' || backendMsg === 'err.unauthorized') {
                        alert('Unauthorized user. Please log in with the right Frontend-User.');
                    }

                    localStorage.setItem('ids_redirect', state.url);
                    this.userdata.data.next(null);
                    this.router.navigate(['login']);
                    if (err.status !== 403) console.log('error', err);
                    resolve(false);
                }
            });
        });
    }
}
